import { getDatabase, ref, set, remove } from "firebase/database";
import { useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';

export const useAdminActions = () => {
    const allVideos = useSelector((state) => state.allVideos.videos)
    const programCategories = useSelector((state) => state.programCategories.categories)
    const branch = useSelector((state) => state.adminProgram.branch)

    function saveAdminProgram(updatedExercises, programName, category) {
        const db = getDatabase();
        set(ref(db, 'AdminProgramsTreeMulti/' + branch + '/' + category + '/' + programName), { ...updatedExercises });
    }
   

    const reorderProgram = (newTree, programName) => {
        var sortedTreeData = []
        var sPrograms = []
        const category = newTree.find((p) => p.id === programName).parent

        const flattenedAdminPrograms = programCategories && programCategories.flatMap((category) => category.adminPrograms)
        if (flattenedAdminPrograms) {
            const admProgram = flattenedAdminPrograms.find((prog) => prog.id === programName)
            if (admProgram) {
                sortedTreeData = Object.assign([], newTree)
                sortedTreeData.map((item, index) => {
                    if (item.parent === programName) {
                        var foundItem = admProgram.exercises.find((e) => e.id === item.id)
                        if (foundItem) {
                            var copyItem = { ...foundItem }
                            copyItem.idx = index
                            if (!sPrograms.find(p => p.id === copyItem.id)) {
                                sPrograms.push(copyItem)

                            }
                        }
                     
                    }
                    return null
                })
                console.log(sPrograms)
                saveAdminProgram(sPrograms, programName, category)
            }
        }
    }

    const updateUser = (userDetail) => {
        const emailId = userDetail.email.replaceAll(".", "")

        const db = getDatabase();
        set(ref(db, 'Users/' + emailId), { ...userDetail })
    }

    const addAdminProgram = (addedItemId, targetFolder) => {
        if (addedItemId) {
            var flattenedAdminPrograms = programCategories && programCategories.flatMap((category) => category.adminPrograms)
            var vimeoItem = allVideos && allVideos.find((video) => video.id === addedItemId)
            if (vimeoItem) {
                var admProgram = flattenedAdminPrograms.find((prog) => prog.id === targetFolder)
                if (admProgram) {
                    var category = null
                    programCategories && programCategories.map(cat => {
                        var admprog = cat.adminPrograms.find((p) => p.id === admProgram.id)
                        if (admprog) {
                            category = cat
                        }
                        return null
                    })
                    if (category) {
                        var updatedExercises = Object.assign([], admProgram.exercises.filter((p) => p.name !== ''))
                        if (!admProgram.exercises.some((prog) => prog.id === vimeoItem.id)) {
                            updatedExercises.push(vimeoItem);
                            saveAdminProgram(updatedExercises, admProgram.programName, category.name)
                        }
                    }
                }
            }
        }
    }

    const newAdminProgram = (adminProgram) => {
        const exercise = {
            id: uuid(),
            name: "",
            description: "",
            instructions: "",
            idx: 0,
            metricType: 0,
            splitCategory: "",
            isCategory: false,
            folder: '',
            link: '',
            thumbnail: ''
        }
        saveAdminProgram([exercise], adminProgram.programName, adminProgram.categoryName)
    }

    const addProgramExercise = (exercise) => {
        const flattenedAdminPrograms = programCategories && programCategories.flatMap((category) => category.adminPrograms)
        if (flattenedAdminPrograms) {
            const admProgram = flattenedAdminPrograms.find((prog) => prog.id === exercise.programName)
            if (admProgram) {
                var updatedExercises = Object.assign([], admProgram.exercises.filter((p) => p.name !== ''))
                if (!admProgram.exercises.some((prog) => prog.id === exercise.id)) {
                    updatedExercises.push(exercise);
                    saveAdminProgram(updatedExercises, exercise.programName, exercise.categoryName)
                }        
            }
        }
    }

    const editProgramExercise = (exercise) => {
        const programExercise = {
            id: exercise.id,
            name: exercise.name,
            description: exercise.description,
            instructions: exercise.instructions,
            metricType: exercise.metricType,
            splitCategory: '',
            isCategory: false,
            folder: exercise.folder,
            link: exercise.link,
            thumbnail: exercise.thumbnail,
            idx: exercise.idx
        }
        const flattenedAdminPrograms = programCategories && programCategories.flatMap((category) => category.adminPrograms)
        if (flattenedAdminPrograms) {
            const admProgram = flattenedAdminPrograms.find((prog) => prog.id === exercise.programName)
            if (admProgram) {
                var updatedExercises = Object.assign([], admProgram.exercises.filter((p) => p.id !== programExercise.id))
                updatedExercises.push(programExercise);
                saveAdminProgram(updatedExercises, exercise.programName, exercise.categoryName)
            }
        }
    }

    const pasteProgramExercise = (copiedExerciseId, pasteInCategory, pasteInFolder) => {
        if (copiedExerciseId) {
            var foundItem = null
            programCategories && programCategories.map(cat => {
                cat.adminPrograms.map(p => {
                    foundItem = p.exercises.find((e) => e.id === copiedExerciseId)
                    if (foundItem) {
                        var pasteExercise = Object.assign({}, foundItem) 
                        pasteExercise.categoryName = pasteInCategory
                        pasteExercise.programName = pasteInFolder
                        addProgramExercise(pasteExercise)
                    }
                    return null
                })
                return null
            })
        }
    }


    const deleteUserProgram = (node) => {
        var category = ""
        var programName = ""

        var foundItem = programCategories && programCategories.find((cat) => cat.id === node.id)
        if (foundItem) {
            const db = getDatabase();
            remove(ref(db, 'AdminProgramsTreeMulti/' + branch + '/' + foundItem.name))
        } else {
            programCategories && programCategories.map((cat) => {
                foundItem = cat.adminPrograms.find((p) => p.id === node.id)
                if (foundItem) { // delete whole program
                    category = cat.name
                    programName = foundItem.programName
                    const db = getDatabase();
                    remove(ref(db, 'AdminProgramsTreeMulti/' + branch + '/' + category + '/' + programName));
                } else { // must be a single exercise to be deleted
                    foundItem = cat.adminPrograms.find((p) => p.id === node.parent)
                    if (foundItem) {
                        var foundExercise = foundItem.exercises.find((e) => e.id === node.id)
                        if (foundExercise) {
                            const updatedExercises = foundItem.exercises.filter((e) => e.id !== node.id)
                            saveAdminProgram(updatedExercises, foundItem.programName, cat.name)
                        }
                    }
                }
                return null
            })
        }
    }

    return { addAdminProgram, newAdminProgram, deleteUserProgram, updateUser, 
        addProgramExercise, editProgramExercise, pasteProgramExercise, reorderProgram }

}
